import { useAtom, useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';

import { localiseMeasurement } from '@/utils/unitSystem';
import * as state from '@/components/Analysis/state';
import { UnitsEnum } from '@/__generated__/graphql';
import { Viewpoint } from '@/types';

export const useViewpointsByAssembly = (
  assemblyId: string | undefined,
  seenByViewpoints: Viewpoint[] | undefined
): Viewpoint[] => {
  const unitSystem = useAtomValue(state.unitSystem);
  const [viewpointsByAssemblyId, setViewpointsByAssemblyId] = useAtom(state.viewpointsByAssemblyId);

  useEffect(() => {
    const assemblyViewpoints = seenByViewpoints?.map((viewpoint: Viewpoint) => {
      return {
        ...viewpoint,
        distanceDisplayText: localiseMeasurement({
          unitSystem,
          sourceUnit: UnitsEnum.Meter,
          value: viewpoint.distance,
        }),
      };
    });
    if (assemblyViewpoints && assemblyId && viewpointsByAssemblyId[assemblyId] === undefined) {
      setViewpointsByAssemblyId((current) => ({
        ...current,
        [assemblyId]: assemblyViewpoints,
      }));
    }
  }, [assemblyId, seenByViewpoints, setViewpointsByAssemblyId, unitSystem, viewpointsByAssemblyId]);

  const viewpoints = useMemo(() => {
    return assemblyId ? viewpointsByAssemblyId[assemblyId] : undefined;
  }, [viewpointsByAssemblyId, assemblyId]);

  return viewpoints ?? [];
};
